// extracted by mini-css-extract-plugin
export default {"accordion_root":"f8","accordion_summary":"g8","accordion_details_root":"h8","expand_icon":"i8","rotate_arrow":"j8","info_item":"k8","ingredient":"l8","title":"m8","product":"n8","img":"o8"};
    if(module.hot) {
      // 1715276860259
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  